import { createSelector } from 'reselect';

export const peopleSelector = state => state.people;

export const donorsFilterSelector = createSelector(peopleSelector, people => people.donorsFilter);

export const leadsFilterSelector = createSelector(peopleSelector, people => people.leadsFilter);
